import { useQuery } from '@tanstack/react-query';
import { getConcierge } from 'app/services/twilio/concierge';

export const CONCIERGE_KEY = ['concierge'];

export function useConcierge() {
  const { data: concierge } = useQuery({
    queryKey: CONCIERGE_KEY,
    queryFn: getConcierge,
  });

  return concierge;
}
